import { Address } from "viem";
import type { BlockchainTokensType } from "../types";
import { ChainId } from "./chains";


export const wethUsdPair: BlockchainTokensType = {
    [ChainId.SHIBARIUM]: '0xB69A4132af7495aE809Ce0155b7be1889ef72918',
    [ChainId.DOGECHAIN]: '0xB69A4132af7495aE809Ce0155b7be1889ef72918',
    [ChainId.BASE]: '0xB69A4132af7495aE809Ce0155b7be1889ef72918',
    [ChainId.ETH]: '0x5f835420502A7702de50Cd0E78D8aA3608b2137e'
}

export const usdContract: BlockchainTokensType = {
    [ChainId.SHIBARIUM]: '0xaB082b8ad96c7f47ED70ED971Ce2116469954cFB',
    [ChainId.DOGECHAIN]: '0xB69A4132af7495aE809Ce0155b7be1889ef72918',
    [ChainId.BASE]: '0xB69A4132af7495aE809Ce0155b7be1889ef72918',
    [ChainId.ETH]: '0x79A02482A880bCE3F13e09Da970dC34db4CD24d1'
}

export const wethContract: BlockchainTokensType = {
    [ChainId.SHIBARIUM]: '0xC76F4c819D820369Fb2d7C1531aB3Bb18e6fE8d8',
    [ChainId.DOGECHAIN]: '0xB69A4132af7495aE809Ce0155b7be1889ef72918',
    [ChainId.BASE]: '0xB69A4132af7495aE809Ce0155b7be1889ef72918',
    [ChainId.ETH]: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2'
}